import {blogApiClient, hubspotApiClient, mainApiClient} from './HttpClient';

export const postRequest = async <T = unknown,>(path: string, data?: unknown): Promise<T> => {
    const response = await mainApiClient.post<T>(path, data ?? null);
    return response.data;
};

export const BlogPostRequest = async <T = unknown,>(path: string, data?: unknown): Promise<T> => {
    const response = await blogApiClient.post<T>(path, data ?? null);
    return response.data;
};

// signal param enables AbortController cancellation at the call site.
export const getRequest = async <T = unknown,>(path: string, signal?: AbortSignal): Promise<T> => {
    const response = await blogApiClient.get<T>(path, {signal});
    return response.data;
};

export const getPaginatedRequest = async <T = unknown,>(
    path: string,
    signal?: AbortSignal
): Promise<{data: T; totalPages: number; total: number | null}> => {
    const response = await blogApiClient.get<T>(path, {signal});
    const total = Number.parseInt(response.headers['x-wp-total'] ?? '', 10);
    return {
        data: response.data,
        totalPages: Number.parseInt(response.headers['x-wp-totalpages'] ?? '1', 10),
        // Total matching posts across all pages; null when the header is absent.
        total: Number.isNaN(total) ? null : total
    };
};

// Returns both data AND headers — sitemaps need x-wp-totalpages for pagination.
export const GetAllBlogRequest = async <T = unknown,>(path: string): Promise<{data: T; headers: Record<string, string>}> => {
    const response = await blogApiClient.get<T>(path);
    return {data: response.data, headers: response.headers};
};

export const hubSpotPostRequest = async <T = unknown,>(path: string, data: unknown): Promise<T> => {
    const response = await hubspotApiClient.post<T>(path, data);
    return response.data;
};
